module.exports = __webpack_public_path__ + "img/OBJECTS.5c9a449d.svg";